<div class="dropdown-chip-input" (click)="!readonly && focusInput()">
  @for (v of selectedValues; track trackBySelf($index, v)) {
    <span class="dropdown-chip" [class.dropdown-chip--external]="isExternalValue(v)" data-tooltip-no-anchor>
      {{ getLabelFor(v) }}
      <span class="dropdown-chip-remove" (mousedown)="$event.preventDefault()" (click)="remove(v, $event)">&times;</span>
    </span>
  }
  @if (!readonly && (!singleSelect || selectedValues.length === 0)) {
    <input
      #chipInput
      type="text"
      class="dropdown-chip-text-input"
      [placeholder]="selectedValues.length === 0 ? placeholder : addMoreText"
      [ngModel]="searchText"
      (ngModelChange)="onSearchChange($event)"
      (focus)="isOpen = true"
      (blur)="onBlur()"
      autocomplete="off"
      />
  }
</div>
@if (!readonly && isOpen && filteredOptions.length > 0) {
  <div class="chip-dropdown custom-scrollbar">
    @for (opt of filteredOptions; track trackByValue($index, opt)) {
      <div
        class="chip-dropdown-item"
        data-tooltip-no-anchor
        (mousedown)="$event.preventDefault(); select(opt)"
        >
        <div class="chip-opt-label">{{ opt.label }}</div>
        @if (opt.sublabel) {
          <div class="chip-opt-sublabel">{{ opt.sublabel }}</div>
        }
      </div>
    }
  </div>
}
